module.exports = __webpack_public_path__ + "static/media/designer.069b5b5d.jpg";